import styled from "styled-components";

export const TransactionDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  .amount {
    font-size: 40px;
    color: #000;
    font-weight: bold;
  }
`;

export const LabelDetail = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.02em;

  column-gap: 5px;

  .value-detail {
    font-weight: 700;
  }

  .info-label {
    display: flex;
    align-items: center;
    column-gap: 5px;
  }

`;

export const StatusLabel = styled.div`
  margin-left: 7px;
  font-weight: 700;
  border-radius: 15px;
  padding-inline: 9px;
  padding-block: 2px;

  ${(props) => {
    switch (props.status) {
      case "success":
        return `color: #34c293;
                background: #d7fbe1; `;
      case "failure":
        return `color: #FF493F;
                background: #FFE7D8; `;
      case "cancel":
        return `color: #a97a23;
                background: #FFF8CD; `;
      case "review":
        return `color: #545454;
                background: #DBF4FF; `;
      default:
        return `color: #ffffff;
                background: #000000; `;
    }
  }}
`;

export const ReceiptBtn = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding: 16px 8px;
  text-align: center;

  width: 25%;
  font-size: 18px;

  border-radius: 12px;
  border: none;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.12);
  color: ${(props) => props.letterColor || ""};
  background: ${(props) => props.bgColor || "#f1b434"};
  transition-timing-function: ease-in-out;
  transition-duration: 0.1s;
  pointer-events: ${(props) => (props.disabled ? "none" : "")};
  cursor: pointer;

  :hover {
    background: rgba(0, 0, 0, 0.7);
  }

  @media screen and (max-width: 375px) {
    width: 75%;
    font-size: 16px;
  }

  @media screen and (min-width: 376px) and (max-width: 419px) {
    width: 68%;
    font-size: 16px;
  }

  @media screen and (min-width: 420px) and (max-width: 495px) {
    width: 62%;
    font-size: 16px;
  }

  @media screen and (min-width: 496px) and (max-width: 630px) {
    width: 56%;
    font-size: 17px;
  }

  @media screen and (min-width: 631px) and (max-width: 800px) {
    width: 45%;
    font-size: 18px;
  }

  @media screen and (min-width: 801px) and (max-width: 1000px) {
    width: 48%;
    font-size: 18px;
  }

  @media screen and (min-width: 1001px) and (max-width: 1200px) {
    width: 50%;
    font-size: 18px;
  }

  @media screen and (min-width: 1201px) and (max-width: 1350px) {
    width: 40%;
    font-size: 18px;
  }

  @media screen and (min-width: 1351px) and (max-width: 1500px) {
    width: 40%;
    font-size: 18px;
  }

  @media screen and (min-width: 1501px) and (max-width: 1700px) {
    width: 35%;
    font-size: 18px;
  }
`;
